export const isObject = (object: unknown) => {
    return object !== null && typeof object === 'object';
};
